// usePresence — S3: online prítomnosť (kto je v systéme a kde)
// ════════════════════════════════════════════════════════════════════
// Ústava 53.7 — multi-user: vidieť kto ďalší pracuje v Matrixe.
// Pinguje POST /api/user-activity (user_id, user_name, section) a číta
// GET /api/user-activity (online = ping za posledné 2 min, rieši backend).
//
// POUŽITIE:  const online = usePresence(user, 'Faktúry')
//   online = [{ user_id, user_name, section, last_ping }]

import { useState, useEffect, useRef } from 'react'
import { fetchAuth } from '../auth/fetchAuth.js'

const PING_MS = 45_000   // ping + poll každých 45 s (lock-style heartbeat)

export function usePresence(user, section) {
  const [online, setOnline] = useState([])
  const sectionRef = useRef(section)
  sectionRef.current = section

  const uid = user && user.id

  useEffect(() => {
    if (!uid) return
    let cancelled = false

    const ping = async () => {
      try {
        await fetchAuth('/api/user-activity', {
          method: 'POST',
          body: JSON.stringify({
            user_id: uid,
            user_name: (user && (user.display_name || user.username)) || '',
            section: sectionRef.current || '',
          }),
        })
      } catch (_) {}
    }
    const poll = async () => {
      try {
        const r = await fetchAuth('/api/user-activity')
        const d = await r.json()
        if (!cancelled) setOnline(Array.isArray(d) ? d : [])
      } catch (_) {}
    }
    const cycle = () => { ping().then(poll) }

    cycle()
    const iv = setInterval(cycle, PING_MS)
    return () => { cancelled = true; clearInterval(iv) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uid])

  return online
}

export default usePresence
